import type {AnyContext, Register, ResolveParams, SearchSchemaInput} from "@tanstack/react-router";
import type {OfferTemplateNotesSearch} from "./-types";
import {createFileRoute} from "@tanstack/react-router";
import {offerTemplateNotesMessages} from "../../-messages/offer-template-notes.messages";
import {OfferTemplateNotesPage} from "./-page/offer-template-notes.page";
import {OfferTemplateNotesPending} from "./-page/offer-template-notes.pending";
import {offerTemplateNotesSearchSchema} from "./-types";

const validateNotesSearch = (
  search: Partial<OfferTemplateNotesSearch> & SearchSchemaInput,
): OfferTemplateNotesSearch => offerTemplateNotesSearchSchema.parse(search);
export const Route = createFileRoute("/_app/sales/offers/templates/$offerTemplateId/notes/")<
  Register,
  typeof validateNotesSearch,
  ResolveParams<"/">,
  AnyContext,
  AnyContext
>({
  component: RouteComponent,
  pendingComponent: OfferTemplateNotesPending,
  validateSearch: validateNotesSearch,
  staticData: {meta: {labelDescriptor: offerTemplateNotesMessages.notes}},
});
function RouteComponent() {
  const {offerTemplateId} = Route.useParams();
  return <OfferTemplateNotesPage offerTemplateId={offerTemplateId} />;
}
